import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getChildRouterLink, getResourcesRouterLink} from "root/Wieldy/routePaths";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {ResourceTypeFilters} from "root/DataFunctions/Constants";

const ChildResourcesSubmenu = (props ) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    // Ensure we always have a default filter ( From the URL or a default )
    const resource_filter_type = queryParams.type === undefined ? ResourceTypeFilters.FEELINGS : queryParams.type;

    return (
        <AppSidebarGroup title='Resources' default={resource_filter_type}>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources?type=allon')} title="Child's Active Resources" iconName='icon-files' name={'allon'}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources?type=feelings')} title='Feelings' iconName='icon-contacts' name={ResourceTypeFilters.FEELINGS} />
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources?type=learning')} title='Learning' iconName='icon-graduation' name={ResourceTypeFilters.LEARNING}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources?type=game')} title='Games' iconName='icon-inbuilt-apps' name={ResourceTypeFilters.GAME}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources?type=help')} title='Help' iconName='icon-question-circle' name={ResourceTypeFilters.HELP}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'resources?type=all')} title='All Resources' iconName='icon-files' name={ResourceTypeFilters.ALL}/>

        </AppSidebarGroup>
    )
}

export default ChildResourcesSubmenu ;